<template>
  <div class="container">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <div class="empowerment-part part1">
      <p class="title">保险业务赋能</p>

      <p class="content">通过专业数据分析能力，协助保险机构将其存量静默用户重新激活，引导投保，变成活跃在保用户，从而实现存量用户的盘活与转化。</p>

      <ul class="items">
        <li class="item" v-for="(item,index) in cooperations" :key="item.name">
          <img :src="item.img" />
          <p class="title">{{item.name}}</p>
        </li>
      </ul>
    </div>
    <!-- <div class="empowerment-part part2">
      <p class="title">保险经纪代理公司赋能</p>
      <ul class="items">
        <li class="item" v-for="(item,index) in features" :key="item.name">
          <img :src="item.img" />
          <div class="item-body">
            <p class="title">{{item.name}}</p>
            <p class="remark">{{item.remark}}</p>
          </div>
        </li>
      </ul>
    </div> -->
    <div class="empowerment-part part3">
      <p class="title">异业转化赋能</p>

      <div class="part3-body">
        <img class="part3-img" :src="img01" alt="">
        <span class="part3-text1">大数据+人工智能</span>
        <span class="part3-text2">完成转化提高收益</span>
        <span class="part3-text3">业务公司用户</span>
        <span class="part3-text4">异业用户转化</span>
      </div>

      <p class="content">依托资源与技术的高效融合，支持保险机构通过多样化手段将非保险业务存量用户转化保险用户，从而提升保险机构的业务营销广度与深度。</p>
    </div>
    <!-- <div class="empowerment-part part4">
      <p class="title">健康赋能-电话医生</p>

      <ul class="items">
        <li class="item" v-for="(item,index) in phoneDoctorFeatures" :key="item.name">
          <img :src="item.img" />
          <p class="title"  v-html="item.name"></p>
        </li>
      </ul>
    </div> -->

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/Header"
  import Footer from "@/components/Footer"
  import Banners from "@/components/Banners"

  export default {
    name: 'Big_Data',
    data() {
      return {
        banner: require("@/assets/imgs/bg-banner-bigdata.png"),
        cooperations: [
          {
            img: require("@/assets/imgs/icon-insurance-01.png"),
            name: ''
          },
        //   {
        //     img: require("@/assets/imgs/icon-insurance-02.png"),
        //     name: ''
        //   },
          {
            img: require("@/assets/imgs/icon-insurance-03.png"),
            name: ''
          },
          {
            img: require("@/assets/imgs/icon-insurance-04.png"),
            name: ''
          },
        ],
        phoneDoctorFeatures: [
          {
            img: require("@/assets/imgs/img-phone-doctor-1.png"),
            name: '7*24小时</br>在线服务'
          },
          {
            img: require("@/assets/imgs/img-phone-doctor-2.png"),
            name: '轻症直接开据</br>电子处方'
          },
          {
            img: require("@/assets/imgs/img-phone-doctor-3.png"),
            name: '重症疾病</br>绿色通道'
          },
          {
            img: require("@/assets/imgs/img-phone-doctor-4.png"),
            name: '定期</br>电话回访'
          },
        ],
        features: [
          {
            img: require("@/assets/imgs/img-insurance-01.png"),
            name: '精准获客',
            remark: '通过大数据技术精准获客',
          },
          {
            img: require("@/assets/imgs/img-insurance-02.png"),
            name: '引导投保',
            remark: '个性化推荐保险产品',
          },
          {
            img: require("@/assets/imgs/img-insurance-03.png"),
            name: '在线客服',
            remark: '引导用户投保全链路优化',
          },
          {
            img: require("@/assets/imgs/img-insurance-04.png"),
            name: '自动续期',
            remark: '自动续期管理助力保费快速增长',
          },
        ],
        img01: require("@/assets/imgs/img-insurance-05.png"),
      }
    },
    components: {
      Header, Banners,Footer
    },
    created() {
      this.$store.commit('changeNavs', 'Big_Data')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .container {
    min-width: 1350px;

    .empowerment-part {
      width: 100%;
      margin: 0 auto;
      height: 500px;
      padding-top: 50px;
      p {
        margin: 0;
      }
      >.title {
        height:50px;
        font-size:40px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-bottom: 40px;
      }
      >.sub_title {
        height:40px;
        font-size:30px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin: 29px 0 70px;
      }

      .content {
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:33px;
        margin-bottom: 50px;
        text-align: center;
      }

      .items {
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;
        width: 1200px;
        min-height: 270px;

        .item {
          width: 25%;
          list-style: none;
          float: left;
          p{
            text-align: center;
          }
          &.active>img{
            -moz-animation: RotateY 0.5s linear forwards;
            -ms-animation: RotateY 0.5s linear forwards;
            -webkit-animation: RotateY 0.5s linear forwards;
            -o-animation: RotateY 0.5s linear forwards;
            animation: RotateY 0.5s linear forwards;
          }
          >img {
            width: 183px;
            height: 183px;
            border-radius: 8px;
            margin: 0 auto;
            display: block;
            object-fit: scale-down;
            /*opacity: 0;*/
            /*transform:RotateY(90deg);*/
            /*-ms-transform:RotateY(90deg); 	!* IE 9 *!*/
            /*-moz-transform:RotateY(90deg); 	!* Firefox *!*/
            /*-webkit-transform:RotateY(90deg); !* Safari 和 Chrome *!*/
            /*-o-transform:RotateY(90deg); 	!* Opera *!*/
          }
          >.title {
            height:30px;
            font-size:24px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin-top: 20px;
          }
          >.remark {
            height:25px;
            font-size:18px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(136,136,136,1);
            margin: 12px 0;
          }
        }
      }

    }
    .part1 {
    //   height: 580px;
      .content {
        width: 600px;
        margin: 0 auto 20px;
      }
    }
    .part2 {
      background-color: #f4f4f4;
      height: 530px;
      .items {
        box-sizing: border-box;
        padding: 50px 100px 0;
        .item {
          width: 50%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 60px;
          padding-right: 50px;
          box-sizing: border-box;
          img {
            width: 110px;
            height: 110px;
          }
          .item-body {
            width: 250px;
            /*margin-left: 30px;*/
            p {
              text-align: left;
            }
            .title {
              font-size: 22px;
              margin-bottom: 10px;
            }
            .remark {
              font-size: 20px;
            }
          }
        }
      }
    }
    .part3 {
      height:  600px;
      .part3-body {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        height: 350px;
        .part3-img {
          width: 250px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        span {
          font-weight: 600;
        }
        .part3-text1 {
          position: absolute;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
        }
        .part3-text2 {
          position: absolute;
          top: 50%;
          left: 300px;
          transform: translateY(-50%);
        }
        .part3-text4 {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
        }
        .part3-text3 {
          position: absolute;
          top: 50%;
          right: 300px;
          transform: translateY(-50%);
        }
      }
      .content {
        margin: 40px auto;
        width: 700px;
      }
    }
    .part4 {
      background-color: #f4f4f4;
      .items {
        margin-top: 70px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Big_Data.vue